import React from "react";
import { useNavigate } from "react-router-dom";
import "./heroSection.css";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className='hero'>
      {/* Background glow shapes (ONLY PINK/RED) */}
      <div className='hero-bg-blur pink' />
      <div className='hero-bg-blur red' />

      {/* LEFT CONTENT */}
      <div className='hero-left'>
        <h1>
          Find Your <span>Perfect Life Partner</span> with Confidence
        </h1>

        <p className='hero-subtext'>
          Join thousands of verified profiles and discover meaningful connections built on trust, values, and
          compatibility.
        </p>

        <div className='hero-actions'>
          <button className='btn-primary' onClick={() => navigate("/dashboard")}>
            Start Finding Matches
          </button>

          <button className='btn-outline' onClick={() => navigate("/register")}>
            Create Free Profile
          </button>
        </div>
      </div>

      {/* RIGHT VISUAL */}
      <div className='hero-right'>
        <div className='image-card main'>
          <img src='/heroLogo.jpg' alt='couple' />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
